import { Action } from '@ngrx/store';
import { Credentials } from '@app/auth/models/credentials';

export enum LoginPageActionTypes {
  Login = '[Login Page] Login',
}

export class Login implements Action {
  readonly type = LoginPageActionTypes.Login;

  constructor(public payload: { credentials: Credentials,  redirectURL: string | null }) {}
}

export type LoginPageActionsUnion = Login;
